import { Card } from '../ui/card';

const NotebookDetailLoader = () => {
  return (
    <div className="flex-1 p-6">
      {/* Header Skeleton */}
      <div className="flex items-start justify-between mb-6">
        <div className="flex flex-col gap-3">
          <div className="w-10 h-10 bg-gray-400 rounded-full animate-pulse" />
          <div className="h-6 bg-gray-400 w-48 rounded animate-pulse" />
          <div className="flex gap-2">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-4 w-24 bg-gray-300 rounded animate-pulse" />
            ))}
          </div>
        </div>

        <div className="flex gap-2 pt-2">
          <div className="w-10 h-10 rounded-full bg-gray-400 animate-pulse" />
          <div className="w-10 h-10 rounded-full bg-gray-400 animate-pulse" />
        </div>
      </div>

      {/* Filters */}
      <div className="flex items-center gap-2 mb-6 overflow-x-auto">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-7 w-24 bg-gray-300 rounded-full animate-pulse" />
        ))}
      </div>

      {/* Pie Chart Section */}
      <div className="bg-[var(--q3-surface-default)] border border-[var(--q3-stroke-normal)] rounded-lg p-6 mb-6">
        <div className="flex gap-8 items-start">
          <div className="min-w-[200px] space-y-2">
            <div className="h-5 w-40 bg-gray-300 rounded animate-pulse" />
            <div className="h-4 w-56 bg-gray-300 rounded animate-pulse" />
          </div>
          <div className="w-20 aspect-square rounded-full bg-gray-300 animate-pulse" />
          <div className="flex flex-col gap-2">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-4 w-40 bg-gray-300 rounded animate-pulse" />
            ))}
          </div>
        </div>
      </div>

      {/* Questions Skeleton */}
      <div className="space-y-4 mb-6">
        {[...Array(3)].map((_, index) => (
          <Card key={index} className="bg-[var(--q3-surface-default)] rounded-lg shadow-none py-4 px-4">
            <div className="flex flex-col gap-3">
              <div className="h-5 w-3/4 bg-gray-300 rounded animate-pulse" />
              <div className="h-4 w-1/2 bg-gray-300 rounded animate-pulse" />
              <div className="flex gap-3">
                <div className="h-3 w-20 bg-gray-300 rounded animate-pulse" />
                <div className="h-3 w-28 bg-gray-300 rounded animate-pulse" />
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Pagination */}
      <div className="flex items-center justify-center gap-2 mt-6">
        <div className="h-10 w-20 bg-gray-300 rounded animate-pulse" />
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-10 w-10 bg-gray-300 rounded animate-pulse" />
        ))}
        <div className="h-10 w-16 bg-gray-300 rounded animate-pulse" />
      </div>
    </div>
  );
};

export default NotebookDetailLoader;
